<template lang="html">
    <div
        ref="loader"
        class="vx-spinner vs-con-loading__container loader"
        :style="styles"
        :class="{ inactive: !active }"
    ></div>
</template>

<script>
export default {
    name: 'vx-spinner',
    props: {
        type: {
            type: String,
            default: 'default',
            validator: function (value) {
                // The value must match one of these strings
                return (
                    [
                        'default',
                        'point',
                        'radius',
                        'corners',
                        'border',
                        'sound',
                        'material'
                    ].indexOf(value) !== -1
                )
            }
        },
        scale: {
            type: [String, Number],
            default: 1
        },
        active: {
            type: Boolean,
            default: true
        },
        color: {
            type: String,
            default: 'primary'
        },
        background: {
            type: String,
            default: 'transparent'
        },
        text: {
            type: String,
            default: null
        }
    },
    watch: {
        settings(val) {
            this.renderLoader()
        }
    },
    computed: {
        loader() {
            return this.$refs.loader
        },
        styles() {
            // 4 is a magic constant, gives correct height based on scale
            return `height: ${this.scale * 4}rem;`
        },
        settings() {
            return {
                type: this.type,
                text: this.text,
                color: this.color,
                scale: this.scale,
                background: this.background
            }
        }
    },
    methods: {
        renderLoader() {
            this.$nextTick(() => {
                this.$vs.loading.close(this.loader)
                this.$vs.loading({
                    ...this.settings,
                    container: this.loader,
                    textAfter: true
                })
            })
        }
    },
    mounted() {
        this.renderLoader()
    }
}
</script>

<style scoped>
.vx-spinner {
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>

<style lang="stylus">
.loader
  overflow visible
  margin 2px
  transition all .3s ease
  &.inactive
    opacity 0 !important
    transform scale(.5)
</style>
